import type { Ref } from 'vue';
import type { CountryTag } from '@/shared/api/experience';
import { SpecialTagsOrder, specialTagsSlugs } from '@/widgets/rubricsBlock/tour';
import type { ContextType } from '@/entities/rubrics';

export function useTourCountryTagsFiltering(countryTags: Ref<CountryTag[] | undefined>, context: Ref<ContextType>) {
  const specialTags: Ref<CountryTag[]> = ref([]);
  const popupTags: Ref<CountryTag[]> = ref([]);
  const rubricsTags: Ref<CountryTag[]> = ref([]);

  const filterTags = (tags: CountryTag[] = []) => {
    const special: CountryTag[] = [];
    const popup: CountryTag[] = [];

    const filteredTags = tags.reduce((acc, tag) => {
      const slug = tag.tag_slug ?? '';
      const { is_hidden: isHidden, is_seo_only: isSeoOnly } = tag.flags || {};
      const hasExperience = !!tag?.counters?.[`${context.value}_count`];

      if (specialTagsSlugs.includes(slug) && !isHidden && !isSeoOnly) {
        special.push(tag);
      } else if (isHidden || isSeoOnly) {
        if (!isSeoOnly) {
          popup.push(tag);
        }
      } else if (hasExperience) {
        popup.push(tag);
      }

      if (!isHidden && !isSeoOnly && !specialTagsSlugs.includes(slug) && hasExperience) {
        acc.push(tag);
      }

      return acc;
    }, [] as CountryTag[]);

    specialTags.value = special;
    popupTags.value = popup;

    return filteredTags;
  };

  const sortSpecialTags = () => {
    specialTags.value.sort(
      (a, b) =>
        (SpecialTagsOrder[a?.tag_slug] || SpecialTagsOrder.default) -
        (SpecialTagsOrder[b?.tag_slug] || SpecialTagsOrder.default),
    );
  };

  watch(
    () => countryTags.value,
    () => {
      specialTags.value = [];
      popupTags.value = [];

      const filteredTags = filterTags(countryTags.value ?? []);
      sortSpecialTags();
      popupTags.value = specialTags.value.concat(filteredTags);
      rubricsTags.value = specialTags.value.concat(filteredTags);
    },
    { deep: true, immediate: true },
  );

  return { popupTags, rubricsTags };
}
